import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import '../Categories/categories.css';

const MyTooltipOffCanvas = ({myTooltip, menu}) => {
  const [targetURL, setTargetURL] = useState('#');
  const handleLink = (e) =>{
    if (menu==='Categorias') {
      setTargetURL('#');
      return
    }
    const baseUrl = "https://www.miniso.com.mx/";
    let tempUrl = `${baseUrl}`;
    let data = e.target.innerText.toLowerCase();
    let dataToUrl= data.replace(',','').split(' ').join('-');
    let menuToUrl= menu.toLowerCase().replace(',','').split(' ').join('-');
    if (data.includes('we bear bears')) data='osos-escandalosos';
    else if (data.includes('tom y jerry')) data='tom-jerry';
    else data=dataToUrl;
    if (menu==='Coca-Cola') tempUrl+=data;
    else tempUrl+=`${menuToUrl}/${data}`;
    setTargetURL(tempUrl);
    //console.log(data);
  }
  return (
    <OverlayTrigger
          
          placement={'bottom'}
          overlay={menu==='Categorias'?<Tooltip style={{display:'none'}}/>:
            <Tooltip id={`tooltip-bottom`}>
              {myTooltip}
            </Tooltip>
          }
        >
          <a style={{textDecoration:'none', color:'inherit'}} href={targetURL}>
          <h6 onMouseOver={handleLink} className='ms-4 p-2 ps-3 fw-light bgRosaHover w-50'>{myTooltip}</h6> 
          </a>
          
        </OverlayTrigger>
  )
}

export default MyTooltipOffCanvas